/* eslint-disable import/no-extraneous-dependencies */
import React, { createElement, useState } from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  CircularProgress,
  Dialog, DialogActions, DialogContent, DialogTitle, IconButton, makeStyles,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { FormProvider, useForm } from 'react-hook-form'
import useWidth from '@hooks/useWidth'
// import { DevTool } from '@hookform/devtools'

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  closeButton: {
    marginRight: theme.spacing(1),
  },
  btnWrapper: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse',
      width: '100%',
    },
  },
  button: {
    margin: theme.spacing(1),
    minWidth: 200,
  },
  txTitle: {
    fontWeight: 'bold',
  },
}))

const AddDialogForm = ({
  open,
  toggleDialog,
  title,
  forms,
  formComponent,
  resolver,
  defaultValues,
  postData,
  customTitle,
}) => {
  const classes = useStyles()
  const methods = useForm({ resolver, defaultValues })
  const [isSubmitting, setSubmitting] = useState(false)
  const [triggerDisable, setTriggerDisable] = useState(false)
  const width = useWidth()
  const withWidth = ['xs', 'sm']

  const mapForms = () => (
    // eslint-disable-next-line no-unused-vars
    forms.map((form) => createElement(form.component, {
      ...form,
      key: form.name,
      disabled: isSubmitting,
    }))
  )

  const onSubmit = async (value) => {
    setSubmitting(true)
    await postData(value)
    setSubmitting(false)
  }

  return (
    <Dialog
      open={open}
      onClose={toggleDialog}
      maxWidth="lg"
      fullWidth
      fullScreen={withWidth.includes(width)}
    >
      {/* <DevTool control={methods.control} /> */}
      <FormProvider {...methods}>
        <form autoComplete="off" onSubmit={methods.handleSubmit(onSubmit)}>
          <div className={classes.dialogTitle}>
            <DialogTitle className={classes.txTitle}>{customTitle || `Tambah ${title}`}</DialogTitle>
            <IconButton
              size="small"
              className={classes.closeButton}
              onClick={toggleDialog}
            >
              <CloseIcon />
            </IconButton>
          </div>
          <DialogContent>
            {
            formComponent ? createElement(formComponent, { disabled: isSubmitting, setTriggerDisable, dataDefaultValues: defaultValues }) : mapForms()
          }
          </DialogContent>
          <DialogActions>
            <div className={classes.btnWrapper}>
              <Button
                type="button"
                variant="outlined"
                color="primary"
                disabled={isSubmitting}
                className={classes.button}
                onClick={toggleDialog}
              >
                Batal
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={isSubmitting || triggerDisable}
                className={classes.button}
              >
                {isSubmitting ? <CircularProgress size={24} color="secondary" /> : 'Simpan'}
              </Button>

            </div>
          </DialogActions>
        </form>
      </FormProvider>
    </Dialog>
  )
}

AddDialogForm.defaultProps = {
  title: '',
  formComponent: null,
  forms: [],
  resolver: {},
  customTitle: null,
}

AddDialogForm.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string,
  toggleDialog: PropTypes.func.isRequired,
  forms: PropTypes.array,
  formComponent: PropTypes.any,
  resolver: PropTypes.any,
  defaultValues: PropTypes.object.isRequired,
  postData: PropTypes.func.isRequired,
  customTitle: PropTypes.any,
}

export default AddDialogForm
